import { DiscountsService } from "./implementations/discounts.service";
import { useStore } from "vuex";

export default defineNuxtPlugin((nuxtApp) => {
  const discounts = new DiscountsService(
    nuxtApp.$axios,
    nuxtApp.$config.public.sgApiUrl,
    useStore()
  );

  return {
    provide: {
      discounts: discounts,
    },
  };
});
